module.exports = __webpack_public_path__ + "img/sameday-inactive.813df7f6.svg";